import React from 'react'
import { Link, withSiteData } from 'react-static'
import { TextField, Typography, Paper, Button, Badge } from '@material-ui/core/'
import logoImg from '../content/logo.png'
import withStyles from '@material-ui/core/styles/withStyles'

const styles = theme => ({
    container: {
      margin:'1em 1em 0em 1em',
      height:'100vh',
    },
    textField: {
      marginLeft: theme.spacing.unit,
      marginRight: theme.spacing.unit,
      width: 200,
    },
    menu: {
      width: 200,
    },
    paper: {
      height: '100vh',
    }
});


class Legalities extends React.Component {

  state = {
    name: '',
    age: '',
    multiline: 'Controlled',
    currency: 'EUR',
  };

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
    })
  };

  render () {
    const { classes } = this.props
    return (
      <React.Fragment>
      <div className={classes.container}>
        <Typography variant="display1" gutterBottom>Legalities</Typography>
        <Typography variant="body1" gutterBottom>
        Copyright 2019 Kyle Ventures
        </Typography>
      </div>
      </React.Fragment>
    )
  }
}

export default withStyles(styles)(Legalities)


// WEBPACK FOOTER //
// /Users/evank/Documents/dev/kyle.ventures/src/pages/Legalities.js